import { Card } from "react-bootstrap";
import { ErrorBoundary } from '@sentry/react';
import * as Sentry from '@sentry/react';

import styles from './ChartStatCard.module.css';
import BigStat from "./BigStat.jsx";
import DataSource from "./DataSource.jsx";
import CardStatus from "./CardStatus.jsx";

function ChartStatCardError({error}) {
  Sentry.captureException(error);
  return (
    <>
      <Card.Body className={styles.ChartStatCardBody}>
        <h4 className={styles.ChartStatCardTitle}>This data failed to load...</h4>
        <p>The data might be unavailable or an error occurred. Please try again later.</p>
      </Card.Body>
      <div className={styles.ChartArea}></div>
    </>
  );
}

function ChartStatCard({ title, children, time, dataSource, status, ...props }) {
  return (
    <>
      <Card className={styles.ChartStatCard}>
        <ErrorBoundary fallback={ChartStatCardError}>
          <Card.Body className={styles.ChartStatCardBody}>
            <h4 className={styles.ChartStatCardTitle}>{title}</h4>
            <BigStat {...props} />
            {status && <CardStatus status={status} className={styles.ChartStatCardStatus} />}
          </Card.Body>
          <div className={styles.ChartArea}>{children}</div>

          {time && <div className={styles.ChartStatCardTime}>{new Date(time).toLocaleString('en-AU')}</div>}
        </ErrorBoundary>
        <DataSource dataSource={dataSource} />
      </Card>
    </>
  );
}

export default ChartStatCard
